import { inject, Injectable } from '@angular/core';
import { CredentialsCurrentUser } from '@app/core';
import { UserBrandSetting } from '@app/core/services/api/API.service';
import { UserBrandSettingService } from '@app/core/api/services';
import { ROLES_GROUPS } from '@app/constants';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UserBrandSettingPreloadService {
    private _userBrandSettingService = inject(UserBrandSettingService);

    private _setting$ = new BehaviorSubject<UserBrandSetting | null>(null);
    private _sessionScope: string | null = null;
    private _hasLoaded = false;

    get setting$(): Observable<UserBrandSetting | null> {
        return this._setting$.asObservable();
    }

    getSettingSnapshot(): UserBrandSetting | null {
        return this._setting$.getValue();
    }

    async loadForUser(
        user: CredentialsCurrentUser | null
    ): Promise<UserBrandSetting | null> {
        if (!user?.brandId || !ROLES_GROUPS.MKT_GROUP.includes(user.role)) {
            this.clear();
            return null;
        }

        const scopeKey = `${user.id}:${user.brandId}`;
        if (this._hasLoaded && this._sessionScope === scopeKey) {
            return this._setting$.getValue();
        }

        try {
            const setting = await this._userBrandSettingService.getUserBrandSettingById(
                user.brandId
            );
            this._sessionScope = scopeKey;
            this._hasLoaded = true;
            this._setting$.next(setting ?? null);
            return setting ?? null;
        } catch {
            this._sessionScope = scopeKey;
            this._hasLoaded = true;
            this._setting$.next(null);
            return null;
        }
    }

    clear(): void {
        this._sessionScope = null;
        this._hasLoaded = false;
        this._setting$.next(null);
    }
}
